import { render, staticRenderFns } from "./WhatsNewPopoverItem.vue?vue&type=template&id=eb6b755a&"
import script from "./WhatsNewPopoverItem.vue?vue&type=script&lang=js&"
export * from "./WhatsNewPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports